import GlobalBase from '../global-base';

/**
 * The JS controller for global scripts.
 */
class Global extends GlobalBase {

    docReady() {
        console.log('Hey, this is executed globally!');
    }

}

// Export the singleton.
export default new Global();
